var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dapps-button',
    _vm.supported ? '' : 'disabled',
    _vm.title === _vm.dappsTitle.aave ? 'aave-icon' : ''
  ],on:{"click":_vm.navigateTo}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isBeenTwoWeeks),expression:"!isBeenTwoWeeks"}],staticClass:"new-label",attrs:{"src":require('@/assets/images/new-label.png'),"alt":""}}),_c('img',{class:[
      _vm.title === _vm.dappsTitle.ambrpay ? 'ambrpay-icon' : '',
      'dapp-logo',
      'dapps-icon'
    ],attrs:{"src":_vm.supported ? _vm.icon : _vm.iconDisabled,"alt":""}}),_c('div',{staticClass:"title-container"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.desc))])])])}
var staticRenderFns = []

export { render, staticRenderFns }